module.exports = __webpack_public_path__ + "static/media/information.309d71c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SubscriptionExpiryMessage/information.svg
// module id = 336
// module chunks = 0